import { useEffect } from "react";

const useDataRefresh = (callback: () => void, interval: number = 30000) => {
  useEffect(() => {
    // Validate callback function
    if (typeof callback !== "function") {
      console.error("Callback provided to useDataRefresh must be a function");
      return;
    }

    // Set up interval to call the callback function
    const refreshInterval = setInterval(() => {
      callback();
    }, interval);

    // Cleanup interval on component unmount
    return () => clearInterval(refreshInterval);
  }, [callback, interval]);
};

export default useDataRefresh;
